import * as React from 'react';

export const SvgEmailSent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 142 109" height="97px" width="142px" {...props}>
    <g fill="none" fillRule="evenodd" opacity={0.682}>
      <path fill="#A5ABAF" d="M0 0h142v108.805H0z" />
      <path
        d="M71.034 53.88l55.369-43.56c-.293-.06-.568-1.1-.9-1.1H14.552c-.302 0-.58 1.04-.888 1.096L70.03 53.975l1.004-.096zm61.814-35.09c.136.765-.009.31-.164-.142l-40.045 31 40.107 37.264c.1-.38.102-.744.102-1.144V18.79zm-123.628 0c.028.31 0 .765 0 1.26v65.718c0 .406.01.767.124 1.144L49.43 49.65 9.4 18.648l-.178.142zm62.85 51.904a2.592 2.592 0 01-1.615.544 2.55 2.55 0 01-1.6-.544L54.09 59.292l-40.42 37.48c.404.097.8 1.766 1.22 1.766h111.134c.44 0 .835-1.665 1.24-1.767L86.845 59.287 72.07 70.694z"
        fill="#FFF"
      />
    </g>
  </svg>
);
